import type { FC, ReactNode } from 'react';

import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';

export const LogoMenu: FC<{
  logo: ReactNode;
  websiteName: ReactNode;
  subtitle: ReactNode;
}> = ({ logo, websiteName, subtitle }) => {
  return (
    <div className="flex h-[60px] items-center gap-2 xl:h-[45px]">
      <div className="relative size-[26px] xl:size-[45px]">{logo}</div>
      <div className="flex flex-col">
        {websiteName}
        {subtitle}
      </div>
    </div>
  );
};

export const WebsiteSubtitle = () => {
  return (
    <span className="text-blue700 flex items-center justify-start text-[9px] xl:text-sm">
      <IcoMoonIcon
        className="mr-1 size-[9px] xl:size-[14px]"
        iconName="verified"
      />
      <span className="text-[0.5625rem] xl:text-sm">Official Page</span>
    </span>
  );
};
